import { GroupKey } from '@store/billingQueue';

const loadDocument = {
  loading: false,
  data: [],
  filteredDataCount: 0,
  reImportLoading: false,
  downloadLoading: false,
  groupType: 'Accounting Group A' as GroupKey,
};

export const BillingQueueStore = {
  uploadQueue: {
    loading: false,
    data: [],
    filteredDataCount: 0,
  },
  loadDocument: loadDocument,
  approvedQueue: {
    loading: false,
    data: [],
    filteredDataCount: 0,
  },
  pendingApprovalQueue: {
    loading: false,
    data: [],
    filteredDataCount: 0,
  },
  respondedQueue: {
    loading: false,
    data: [],
    filteredDataCount: 0,
  },
  loadDocumentMetaData: {
    metadata: {
      loadStatus: '',
      billedDate: '',
      orderStatus: '',
      orderInvoicedDate: '',
      carrier: '',
      quickPay: null,
    },
    uploaded: {
      rateConfirmation: [],
      carrierInvoice: [],
      billOfLading: [],
      supportingBol: [],
      email: [],
      proofOfDelivery: [],
      lumperReceipt: [],
      misc: [],
      noticeOfAssignment: [],
      insp: [],
      detn: [],
    },
    required: [],
  },
  disputedQueue: {
    loading: false,
    data: [],
    filteredDataCount: 0,
  },
  noaDocument: {
    data: [],
  },
  reviewDocument: {
    data: [],
  },
  unknownDocument: {
    data: [],
  },
};
